::ng-deep app-edit-data-mapping{display:flex;flex-grow:1}::ng-deep app-edit-data-mapping span.link-color{cursor:pointer;color:var(--accent, #175CFF)}
/*# sourceMappingURL=edit-data-mapping.component-NHACJ4ER.css.map */
